export const TREATMENT_FLOW_FEATURE_KEY = 'treatments';

export const TREATMENT_FLOW_TITLE = 'Como funciona o fluxo de Tratamentos';

export const TREATMENT_FLOW_SUBTITLE =
  'O tratamento reúne tudo o que será feito no paciente. Ele percorre este caminho — os itens ramificados são o que pode acontecer em cada etapa.';

export const treatmentFlowStages = [
  {
    key: 'CRIADO',
    label: 'Adicionar Tratamento',
    description:
      'Clique em "Adicionar Tratamento" e informe o profissional responsável e a descrição.',
    branches: [
      {
        label: 'Deletar',
        tone: 'error',
        description:
          'Enquanto não estiver aprovado, o tratamento pode ser deletado através do menu ⋮',
      },
    ],
  },
  {
    key: 'PROCEDIMENTOS',
    label: 'Adicionar Procedimento',
    description:
      'Abra o tratamento e cadastre cada procedimento com dente e valor. O valor total do tratamento é a soma dos procedimentos.',
    branches: [
      {
        label: 'Imprimir Orçamento',
        tone: 'default',
        description:
          '"Imprimir Orçamento" gera o documento para o paciente levar ou assinar em papel.',
      },
    ],
  },
  {
    key: 'APROVADO',
    label: 'Aprovado',
    description:
      '"Aprovar Tratamento" registra o aceite do paciente sobre o plano fechado e libera a execução.',
    branches: [
      {
        label: 'Não Aprovado',
        tone: 'error',
        description:
          '"Marcar como Não Aprovado" registra que o paciente recusou o orçamento, junto com o motivo da recusa.',
      },
      {
        label: 'Não Pode Ser Deletado',
        tone: 'warning',
        description: 'Depois de aprovado, deletar o tratamento fica bloqueado.',
      },
    ],
  },
  {
    key: 'EM_ANDAMENTO',
    label: 'Em Andamento',
    description:
      'A cada sessão, use "Adicionar Evolução" no procedimento para registrar o que foi executado.',
    branches: [
      {
        label: 'Evoluções',
        tone: 'info',
        description: '"Ver Evoluções" mostra o histórico completo daquele procedimento.',
      },
      {
        label: 'Procedimento Finalizado',
        tone: 'success',
        description: '"Finalizar" encerra o procedimento — ele não pode mais ser deletado.',
      },
    ],
  },
  {
    key: 'CONCLUIDO',
    label: 'Concluído',
    description:
      '"Concluir Tratamento" encerra o tratamento. Informe a data de conclusão — já vem preenchida com a data de hoje.',
    branches: [],
  },
  {
    key: 'COBRANCA',
    label: 'Cobrança Gerada',
    description: '"Gerar Cobrança" lança o valor no financeiro do paciente.',
    branches: [
      {
        label: 'A Qualquer Momento',
        tone: 'info',
        description:
          'A cobrança pode sair do tratamento inteiro ou de um procedimento específico, sem esperar a conclusão.',
      },
    ],
  },
];
